import { FC, Fragment } from "react";
import { NormalizedCostWidgetsViewsHierarchySelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/NormalizedCostWidgetsViewsHierarchySelect";
import { NormalizedCostWidgetSetupDateRangeSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/NormalizedCostWidgetSetupDateRangeSelect";
import { NormalizedCostWidgetVisualizationSection } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/visualization/NormalizedCostWidgetVisualizationSection";
import { NormalizedCostWidgetAggregationsSection } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/aggregations/NormalizedCostWidgetAggregationsSection";
import { NormalizedCostWidgetAdvancedSettingsSection } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/advanced-settings/NormalizedCostWidgetAdvancedSettingsSection";

export const NormalizedCostWidgetSetupSidebar: FC = () => {
  return (
    <Fragment>
      <NormalizedCostWidgetsViewsHierarchySelect />
      <NormalizedCostWidgetSetupDateRangeSelect />
      <NormalizedCostWidgetVisualizationSection />
      <NormalizedCostWidgetAggregationsSection />
      <NormalizedCostWidgetAdvancedSettingsSection />
    </Fragment>
  );
};
